export const Divider = {
  baseStyle: {
    border: "solid 1px",
    borderColor: "brand.lightgrey",
    margin: "32px 0px",
  },
};
